import type { DotToUnderscore } from '@dresscode-frontend/utility-types';
import type { ColumnDef } from '@tanstack/table-core';
import { checkMarkColumn } from '@/components/DataTable/Columns/checkMarkColumn';
import { simpleDateColumn } from '@/components/DataTable/Columns/simpleDateColumn';
import { simpleTextColumn } from '@/components/DataTable/Columns/simpleTextColumn';
import { AppUserColumn } from '@/features/app-user/components/AppUserColumn';
import { PersonColumn } from '@/features/app-user/components/PersonColumn';
import type { AlertRowWithUserAndWorker } from '../../-shared/types';
import { ActionsColumn } from '../../../-components/actions-column';
import { AppUserLastActivityColumn } from '../../../-components/app-user-last-activity-column';
import { AppUserPrimaryActionColumn } from '../../../-components/app-usr-primary-action-column';
import IntegratedAppColumn from '../../../-components/integrated-app-column';
type Row = AlertRowWithUserAndWorker;
export const ColumnKey = {
  appUser: 'user',
  worker: 'worker',
  app: 'software',
  actualRoleName: 'user.actualRoleName',
  statusName: 'user.statusName',
  lastSignedInAt: 'user.lastSignedInAt',
  configuredMfa: 'user.configuredMfa',
  createdAt: 'user.createdAt'
} as const;
export const SortableColumnKey = [ColumnKey.appUser, ColumnKey.worker, ColumnKey.app,
// 以下は . -> _ に変換している
'user_actualRoleName', 'user_statusName', 'user_lastSignedInAt', 'user_createdAt'] as const satisfies DotToUnderscore<(typeof ColumnKey)[keyof typeof ColumnKey]>[];
export function useSoftwareAlertsAlumniColumns(): ColumnDef<Row>[] {
  return [AppUserColumn({
    i18nKey: 'appUser',
    minWidth: '360px',
    maxWidth: '400px'
  }), PersonColumn(ColumnKey.worker, {
    i18nKey: 'person',
    minWidth: '360px',
    maxWidth: '400px'
  }), IntegratedAppColumn(ColumnKey.app, {}), simpleTextColumn(ColumnKey.actualRoleName, {
    i18nKey: 'appUserRole',
    sortable: true
  }), simpleTextColumn(ColumnKey.statusName, {
    i18nKey: 'status',
    sortable: true
  }), AppUserLastActivityColumn(ColumnKey.lastSignedInAt, {
    i18nKey: 'lastActivity',
    minWidth: '150px',
    activeAccessorFn: row => row.user.isActive
  }), checkMarkColumn(ColumnKey.configuredMfa, {
    i18nKey: 'configuredMfa',
    sortable: false
  }), simpleDateColumn(ColumnKey.createdAt, 'dateTime', {
    i18nKey: 'createdOn',
    sortable: true
  }), AppUserPrimaryActionColumn(), ActionsColumn()];
}